import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import './Navbar.css'
import { logo2 as l2} from './../../sharedcomponents/ImageScope';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
export default class Navbar extends Component{
    constructor(){
        super();
        this.state={
                visFlex:'flex'
        } 
    }
    toggleBtn(){
        if(this.state.visFlex==='flex'){
            this.setState({
                visFlex:'none'
            });
        }
        else{
            this.setState({
                visFlex:'flex'
            });
        }
        document.querySelector(".navbar-collapse").style.display=this.state.visFlex;
    }
    render(props){
        return(
            <nav className="navbar navbar-expand-lg fixed navbar-dark bg-black">
                <div className="container">
                    <Link className="navbar-toggler logo" to="/" >
                            <img className={'img-logo'} src={l2} alt=""/> 
                    </Link>
                <button className="navbar-toggler btn-menu" onClick={this.toggleBtn.bind(this)} type="button" data-toggle="collapse" data-target="#navbarsExample08" aria-controls="navbarsExample08" aria-expanded="false" aria-label="Toggle navigation">
                      <span className="navbar-toggler-icon"/>
                </button>

                <div className="collapse navbar-collapse">
                    <ul className="navbar-nav mr-auto">
                        <li className="nav-item item-hide">
                            <Link className="nav-link" to="/">
                                <img className={'img-logo'} src={l2} alt="logotipo HS Design"/>
                            </Link>
                        </li>
                        <li className="nav-item ml-3 item-h item-hide">
                            <Link className={`nav-link `} to="/">|</Link>
                        </li>
                        <li className="nav-item ml-1 item-h">
                            <Link className={`nav-link ${this.props.home}`} to="/">Página Inicial{this.props.Inicial}</Link>
                        </li>
                        <li className="nav-item ml-1 item-h">
                            <Link className={`nav-link ${this.props.service}`}to="/services">Serviços</Link>
                        </li>
                        <li className="nav-item ml-1 item-h">
                            <Link className={`nav-link ${this.props.products}`}to="/products">Produtos</Link>
                        </li>
                        <li className="nav-item ml-1 item-h">
                            <Link className={`nav-link ${this.props.gallery}`}to="/gallery">Galeria</Link>
                        </li>
                        <li className="nav-item ml-1 item-h">
                            <Link className={`nav-link ${this.props.about}`}to="/about">Acerca</Link>
                        </li>
                        <li className="nav-item ml-1 item-h">
                            <Link className={`nav-link ${this.props.localization}`}to="/localization">Localização</Link>
                        </li>
                        {/* <li className="nav-item ml-1 item-h">
                            <Link className={`nav-link ${this.props.contactos}`}to="/">Contactos</Link>
                        </li> */}
                    </ul>
                    <div className="hs-home-contactos">
                        <h6 className="ml-1">Telefone: <b style={{fontWeight:'bold'}}>948576847</b></h6>
                        <h6 className="ml-2">/</h6>
                        <h6 className="ml-2">E-mail: <b style={{fontWeight:'bold'}}>hsdesignangola@gmail.com</b></h6>
                        {/* <h6 className="ml-1">/</h6>
                        <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/hsdesignangola" style={{'text-decoration':'none'}}><span aria-hidden="true" className="ml-1 font-icon-social-facebook" style={{color:'#3b75a3'}}></span></a>
                        <h6 className="ml-2">/</h6>
                        <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/hsdesignangola" style={{'text-decoration':'none'}}><span aria-hidden="true" className="ml-1 font-icon-social-whataspp" style={{color:'#3b75a3'}}></span></a> */}

                    </div>
                </div>
                </div>
            </nav>
        );
    }
}